/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalReferralCreateDto } from '../models/ExternalReferralCreateDto';
import type { ExternalReferralDto } from '../models/ExternalReferralDto';
import type { ExternalReferralInfoDto } from '../models/ExternalReferralInfoDto';
import type { ExternalReferralStatusChangeDto } from '../models/ExternalReferralStatusChangeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class ExternalReferralService {

    /**
     * Dummy endpoint for external referral provider auth
     * @returns any
     * @throws ApiError
     */
    public static externalReferralControllerGetDummy(): CancelablePromise<any> {
        return __request({
            method: 'GET',
            path: `/external-referral/dummy`,
        });
    }

    /**
     * Create external referral
     * @param requestBody
     * @returns any
     * @returns ExternalReferralDto
     * @throws ApiError
     */
    public static externalReferralControllerCreate(
        requestBody: ExternalReferralCreateDto,
    ): CancelablePromise<any | ExternalReferralDto> {
        return __request({
            method: 'POST',
            path: `/external-referral`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Changes the status of an external-referral
     * @param id
     * @param requestBody
     * @returns ExternalReferralInfoDto
     * @throws ApiError
     */
    public static externalReferralControllerChangeStatus(
        id: string,
        requestBody: ExternalReferralStatusChangeDto,
    ): CancelablePromise<ExternalReferralInfoDto> {
        return __request({
            method: 'PATCH',
            path: `/external-referral/${id}/status`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}